export default "__VITE_ASSET__B00ZuX7W__"